import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Segment, Button } from 'semantic-ui-react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import CountDownTimer from '../../app/common/util/CountDownTimer';
import './style.css';
import { verifyTwoFALogin, generateTwoFaOtp, changeResendStatus } from './twoFAactions';
import { twoFAConfig } from './config';

const mapState = state => ({
  auth: state.auth,
  loading: state.async.loading,
  twofa: state.twofa
});

const actions = {
  verifyTwoFALogin,
  generateTwoFaOtp,
  changeResendStatus
};

class TwoFAModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    verifyTwoFALogin: PropTypes.func.isRequired,
    generateTwoFaOtp: PropTypes.func.isRequired,
    auth: PropTypes.object,
  };

  state = {
    twoFaFirst: '',
    twoFaSecond: '',
    twoFaThird: '',
    twoFaFourth: ''
  };

  handleTwoFaOTPChange = event => {
    const targetName = event.target.name,
          targetValue = event.target.value;

    let setFocusOn = '';

    if (targetValue.length === 1) {
      switch (targetName) {
        case 'twoFaFirst':
          setFocusOn = this.twoFaSecond;
          break;
        case 'twoFaSecond':
          setFocusOn = this.twoFaThird;
          break;
        case 'twoFaThird':
          setFocusOn = this.twoFaFourth;
          break;
        default:
          setFocusOn = this.twoFaFirst;
      }
    }

    if (setFocusOn.focus && typeof setFocusOn.focus === 'function') setFocusOn.focus();
    this.setState({ [targetName]: targetValue });
  };

  handleResendTwoFaOTP = (e) => {
    e.preventDefault();
    this.props.generateTwoFaOtp(this.props.auth.user.otpId, this.props.auth.csrfRequestIdentifier);
  };

  handleResendStatusChange = (resendStatusFlag) => {
    this.props.changeResendStatus(resendStatusFlag);
  }

  handleSubmit = values => {
    const { verifyTwoFALogin, auth: { user, csrfRequestIdentifier } } = this.props;
    if(typeof user === 'object' && user.otpId) {
      let otpValue = (this.state.twoFaFirst || 0) + (this.state.twoFaSecond || 0) + (this.state.twoFaThird || 0) + (this.state.twoFaFourth || 0);
      verifyTwoFALogin(otpValue, user, csrfRequestIdentifier);
    }
  };

  render() {
    let disclaimer = '';
    if (this.props.disclaimerHeading && this.props.disclaimerContent) {
      disclaimer = (
        <div>
          <div className="disclaimer-heading">{ this.props.disclaimerHeading }</div>
          <p className="disclaimer-content">{ this.props.disclaimerContent }</p>
        </div>
      );
    }
    return (
      <Modal size="tiny" open={true}>
        <Modal.Header>{ this.props.heading }</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Segment className="no-border-segment" textAlign="center">
              <p>{ this.props.subHeading }</p>
              <p className={ 'number' + (this.props.isNumberVisible ? '' : ' hide') }>
                <span>{ twoFAConfig.MobileCountryCode }</span>
                { this.props.otpDetails && this.props.otpDetails.mobileNumber
                  ? this.props.otpDetails.mobileNumber
                  : this.props.mobileNo
                }
              </p>
              { !this.props.twofa.showResend &&
                <CountDownTimer duration = { twoFAConfig.TimerDuration } decreaseBy = { twoFAConfig.TimerDecreaseBy } changeResendStatus = { this.handleResendStatusChange }/>
              }
            </Segment>
            <Form className = "two-fa-auth" onSubmit={this.props.handleSubmit(this.handleSubmit)}>
              <Segment className="no-border-segment" textAlign="center">
                <input ref={ input => { this.twoFaFirst = input; } }
                        name="twoFaFirst"
                        autoComplete="off"
                        placeholder=""
                        type="tel"
                        onChange={this.handleTwoFaOTPChange}
                        maxLength="1"
                />
                <input ref={ input => { this.twoFaSecond = input; } }
                        name="twoFaSecond"
                        autoComplete="off"
                        placeholder=""
                        type="tel"
                        onChange={this.handleTwoFaOTPChange}
                        maxLength="1"
                />
                <input ref={ input => { this.twoFaThird = input; } }
                        name="twoFaThird"
                        autoComplete="off"
                        placeholder=""
                        type="tel"
                        onChange={this.handleTwoFaOTPChange}
                        maxLength="1"
                />
                <input ref={ input => { this.twoFaFourth = input; } }
                        name="twoFaFourth"
                        autoComplete="off"
                        placeholder=""
                        type="tel"
                        onChange={this.handleTwoFaOTPChange}
                        maxLength="1"
                />
              </Segment>
              { this.props.twofa.showResend &&
                <React.Fragment>
                  <Segment className="no-border-segment remove-padding" textAlign="center">
                    <p>{ twoFAConfig.OTPHelpText }</p>
                    <Button className="buttonLink" onClick={this.handleResendTwoFaOTP}>{ twoFAConfig.ResendText }</Button>
                  </Segment>
                  <Segment className="no-border-segment remove-padding" textAlign="center">
                    <Button className="fcbtn fcprimary small" type="submit">{ this.props.ctaText }</Button>
                  </Segment>
                </React.Fragment>
              }
            </Form>
            <Segment className="no-border-segment" textAlign="center">
              { disclaimer }
            </Segment>
          </Modal.Description>            
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  mapState,
  actions
)(
  reduxForm({ form: 'twoFAForm', enableReinitialize: true })(TwoFAModal)
);